import { z } from 'zod';
import dayjs from 'dayjs';

export const dndSchema = z.object({
  status: z.string().min(1, 'Message is required').max(100, 'Status must be at most 100 characters'),
  time: z
    .string()
    .min(1, 'Time is required')
    .refine((val) => dayjs(val, 'HH:mm:ss', true).isValid(), {
      message: 'Invalid time format',
    }),

  date: z
    .string()
    .min(1, 'Date is required')
    .refine((val) => dayjs(val, 'YYYY-MM-DD', true).isValid(), {
      message: 'Invalid date format',
    }),
});
